import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd041aService,
  Sgkd041aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd019dSgkd041aService {

  private _rsesult$ = new Subject<Sgkd041aResponse>();

  // get contractorValueChanges(): Observable<Sgkd041aResponse> {
  //   return this._rsesult$.asObservable();
  // }

  constructor(
    private sgkd041aService: Sgkd041aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 発行元情報取得API呼び出し
   *
   * @memberof UsedSgkd019dSgkd041aService
   */
  loadHakkomoto(): Observable<Sgkd041aResponse> {

    return this.sgkd041aService.doSGKD041APost(this.apiCommonService.setRequestCommon({}), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD041A');
          return throwError(err.message);
        }
      )
    );
  }
}
